// Authentication helper fonksiyonları
import { supabase } from '../webSupabaseClient';

// Mevcut session'ı al
export const getCurrentSession = async () => {
  try {
    const { data: { session }, error } = await supabase.auth.getSession();
    if (error) {
      console.error('Session alınırken hata:', error);
      return null;
    }
    return session;
  } catch (error) {
    console.error('Session kontrolü başarısız:', error);
    return null;
  }
};

// Token'ı al
export const getAuthToken = async () => {
  try {
    const session = await getCurrentSession();
    return session?.access_token || null;
  } catch (error) {
    console.error('Token alınırken hata:', error);
    return null;
  }
};

// Kullanıcının admin olup olmadığını kontrol et
export const isUserAdmin = async () => {
  try {
    const session = await getCurrentSession();
    return session?.user?.app_metadata?.roles?.includes('admin') || false;
  } catch (error) {
    console.error('Admin kontrolü başarısız:', error);
    return false;
  }
};

// Authentication headers'ı hazırla
export const getAuthHeaders = async () => {
  const token = await getAuthToken();
  const headers = {
    'Content-Type': 'application/json',
  };
  
  if (token) {
    headers.Authorization = `Bearer ${token}`;
  }
  
  return headers;
};